import { HttpInterceptorFn, HttpErrorResponse } from '@angular/common/http';
import { throwError } from 'rxjs';
import { catchError } from 'rxjs/operators';
import { inject } from '@angular/core';
import { LogService } from '../../../services/log.service';

export const httpErrorInterceptor: HttpInterceptorFn = (req, next) => {
  const log = inject(LogService);
  return next(req).pipe(
    catchError((error: HttpErrorResponse) => {
      let errorMessage = 'Une erreur est survenue';
      let shouldLog = true;

      if (error.error instanceof ErrorEvent) {
        // Erreur côté client
        errorMessage = error.error.message || 'Erreur de connexion';
      } else {
        // Erreur côté serveur - messages plus user-friendly
        const serverMessage = error.error?.message || error.error?.error;

        switch (error.status) {
          case 0:
            // Ne pas logger les erreurs réseau si l'utilisateur est hors ligne
            // Ces erreurs sont normales et gérées par l'application
            if (!navigator.onLine) {
              shouldLog = false;
            }
            errorMessage =
              'Impossible de contacter le serveur. Vérifiez votre connexion.';
            break;
          case 400:
            errorMessage = serverMessage || 'Requête invalide.';
            break;
          case 401:
            errorMessage = serverMessage || 'Identifiants incorrects.';
            break;
          case 403:
            errorMessage = serverMessage || 'Accès non autorisé.';
            break;
          case 404:
            errorMessage = serverMessage || 'Ressource introuvable.';
            break;
          case 500:
            errorMessage =
              serverMessage || 'Erreur serveur. Veuillez réessayer plus tard.';
            break;
          default:
            errorMessage =
              serverMessage || `Erreur ${error.status}: ${error.statusText}`;
        }
      }

      // Logger uniquement les erreurs importantes
      // Pas les erreurs réseau hors ligne, ni les 404 sur clusters (attendus)
      if (shouldLog) {
        const isExpected404 =
          error.status === 404 && req.url.includes('/api/clusters/');
        if (!isExpected404) {
          log.error('HTTP Error', {
            url: req.url,
            method: req.method,
            status: error.status,
            message: error.message,
          });
        }
      }

      // On retourne l'erreur originale avec le message amélioré
      const enhancedError = {
        ...error,
        error: {
          ...error.error,
          message: errorMessage,
        },
      };

      return throwError(() => enhancedError);
    }),
  );
};
